import React,{useEffect} from 'react';

import { useLocation } from 'react-router-dom';

import Header from '../../components/Header/Header';

import { Outlet } from 'react-router-dom';

import { useGlobalContext } from '../../context';

import Footer from '../../components/Footer/Footer';

import BookList from "../../components/BookList/BookList";

const Home = () => {
  const location = useLocation();
  const {searchCriteria,setSearchCriteria} = useGlobalContext(); 
  const {setSearchTerm} = useGlobalContext();

  useEffect(() => {
   
    if (!location.pathname.includes('/book') && !location.pathname.includes('/journal')) {
      searchCriteria.isSearching === false && setSearchTerm("");
      setSearchCriteria(prevCriteria => ({
        ...prevCriteria, // Keep the existing state
        location: "main",
        allFilter:prevCriteria.isSearching === false? "category":"book",
        
      }));
    } else if (location.pathname.includes('/book')) {
      
      if(!Number(location.pathname.split('/').pop()) ){
      setSearchTerm("");
      setSearchCriteria(prevCriteria => ({
        ...prevCriteria, // Keep the existing state
        type: "book", 
        location:"book",
        allFilter:"book",
        categoryname:"الكتب العلمية لمجمع الملك سلمان العالمي للغة العربية",
        // Set type to "book" when in '/book'
        // category: "", // Consider if you need to clear the category here as well
      }));
    }
    }
    else if (location.pathname.includes('/journal')) {
      setSearchTerm("");
      // console.log(!Number(location.pathname.split('/').pop()));

      if((searchCriteria.category||searchCriteria.category === 0) &&  !Number(location.pathname.split('/').pop()) ){
        
        setSearchCriteria(prevCriteria => ({
          ...prevCriteria, // Keep the existing state
          category: 0,
          type: "journal",
          allFilter:"category",
          categoryname:"المجلات العلمية المحكمة لمجمع الملك سلمان العالمي للغة العربية"
        }));
        
      }else{
        
          setSearchCriteria(prevCriteria => ({
            ...prevCriteria,
            location:"journal",
            //get id from url last elemetn 
            category : location.pathname.split('/').pop(),
            type : searchCriteria.type == "article" ? "article": "journal",
          }));
        }

    }
    
  }, [location.pathname]); // Depend on location.pathname
  

  return (
    <main>

      <Header />
      {(!location.pathname.includes('/book')&&!location.pathname.includes('/journal')) && <BookList />}
      <Outlet />
      <Footer />

    </main>
  );
}

export default Home;
